import { render, staticRenderFns } from "./historySlice.vue?vue&type=template&id=0cbbf196&scoped=true&"
import script from "./historySlice.vue?vue&type=script&lang=ts&"
export * from "./historySlice.vue?vue&type=script&lang=ts&"
import style0 from "./historySlice.vue?vue&type=style&index=0&id=0cbbf196&lang=less&scoped=true&"
import style1 from "./historySlice.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbbf196",
  null
  
)

export default component.exports